export const DetailsComponentTabsData = [
  { tab: 'Related-Districts' },
  { tab: 'Related-Communities' },
  { tab: 'Related-SubCommunities' }
];
